/**
 * Created by linjianxi on 2016/11/17.
 */

import * as actions from './actions'
import * as getters from './getter'
import * as types from './mutation-type'

const state = {
  gridData: {},
  FirstArr: [],
  TwoArr: [],
  ThreeArr: []
}
const mutations = {
  [types.WEEK_TOP_LIST] (state, result) {
    state.gridData = result
    if (result.length > 0) {
      let namesSetFirst = new Set([result[0]])
      let arrFirst = Array.from(namesSetFirst)
      state.FirstArr = arrFirst
    }
    if (result.length > 2) { // 共有2条以上数据(不包含2条)
      let namesSet = new Set([result[1], result[2]])
      let arr2 = Array.from(namesSet)
      state.TwoArr = arr2

      let cout = result.length - 3
      let numArr = []
      for (let i = 0; i < cout; i++) {
        numArr.push(result[i + 3])
      }
      let namesSetThree = new Set(numArr)
      let arr2Three = Array.from(namesSetThree)
      state.ThreeArr = arr2Three
    } else if (result.length !== 1) { // 共有2条数据
      let namesSet = new Set([result[1]])
      let arr2 = Array.from(namesSet)
      state.TwoArr = arr2
    }
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/ticket/store.js